import { useEffect, useState } from "react";
import { API_BASE } from "@/lib/api";

/**
 * Renders the user's profile photo from object storage, with a fallback to
 * initials. Reuses the existing /files/{id}/download endpoint so we don't need
 * a public mirror.
 */
export function UserAvatar({ user, size = 40, className = "" }) {
  const [src, setSrc] = useState(null);
  const fotoId = user?.foto_id;

  useEffect(() => {
    if (!fotoId) {
      setSrc(null);
      return undefined;
    }
    let cancelled = false;
    let blobUrl = null;
    const token = localStorage.getItem("sip_access_token");
    fetch(`${API_BASE}/files/${fotoId}/download`, {
      credentials: "include",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((r) => (r.ok ? r.blob() : null))
      .then((blob) => {
        if (cancelled || !blob) return;
        blobUrl = URL.createObjectURL(blob);
        setSrc(blobUrl);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [fotoId]);

  const initials = (user?.name || user?.username || "?")
    .split(/\s+/)
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const dim = { width: size, height: size };

  if (src) {
    return (
      <img
        src={src}
        alt={user?.name || "Foto profil"}
        style={dim}
        className={`rounded-full object-cover border border-slate-200 ${className}`}
        data-testid="user-avatar-image"
      />
    );
  }
  return (
    <div
      style={dim}
      className={`rounded-full bg-slate-900 text-white grid place-items-center text-xs font-bold ${className}`}
      data-testid="user-avatar-initials"
    >
      {initials}
    </div>
  );
}
